import React from "react";
import {Link} from 'react-router-dom'
import {useForm, FormProvider} from "react-hook-form";

import Button from '@mui/material/Button';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import dayjs from 'dayjs';
import 'dayjs/locale/ro';

import * as ReminderGen from '../../../utils/calculators/ReminderGeneratorIscir';
import * as CustomStyles from '../../styles/CustomStyles';
import CustomSelect from '../../custom/CustomSelectComponent'
import * as SelectTypes from '../../constants/CustomSelectTypes'
import * as ValidationMessages from '../../constants/ValidationMessages';
import * as AuthorizationFragment from './AuthzIscirFragmentComponent';
import {formatAuthzIscirDates} from './AuthzHelper';
import { AuthzIscirAFCode } from "../../constants/Consts";




const AuthorizationIscirNew = (props) => {
    console.log('AuthorizationIscirrNew Component___');

    const methods = useForm({
        defaultValues: {
            lAuthorization: { autorizatie: {employeeId: props.employee.id, workSiteId: props.employee.employmentDetails.workSiteId} },
        } 
    });

    const register = methods.register;
    const handleSubmit = methods.handleSubmit;
    const errors = methods.formState.errors;
    const defaultValues = methods.formState.defaultValues;

    const [selectedAuthorization, setSelectedAuthorization] = React.useState(defaultValues.lAuthorization.autorizatie.authISCIR);

    const handleAuthorizationChange = (authId) => {
        setSelectedAuthorization(authId);
    }

    const handleSubmitAuthzCreate = (data, event) => {
        event.preventDefault();
        const authorization = data.lAuthorization;
        formatAuthzIscirDates(authorization);
        const reminder = ReminderGen.generateReminder(authorization, props.employer.preference);
        if(reminder) {
            authorization.reminder = ReminderGen.getAuthzReminder(reminder);
            reminder.extra = ReminderGen.getReminderExtra(props.employee, props.employer, props.worksite);
        }
        else {
            authorization.reminder = {};
        }
        props.createAuthorization(authorization, reminder);
    }    

    // use 'ro' locale globally
    dayjs.locale('ro');

    return(
        <Container maxWidth="xl" >
        <Box px={{xs: 3, sm: 7}}>

            <Stack spacing={1} sx={{marginBottom: 2}}>
                <Box>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                        <Link to={`/employees/${props.employee.id}`}>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName}</Link>
                        <Typography color="text.primary">
                            Autorizatie ISCIR noua
                        </Typography>
                    </Breadcrumbs>
                </Box>       

                <Box>
                    <h3>{props.employee.generalSection.lastName} {props.employee.generalSection.firstName} - Adauga autorizatie ISCIR</h3>
                </Box>
                <hr/>

                <FormProvider {...methods} > 
                <form id='aaIscirConstructionForm' onSubmit={handleSubmit(handleSubmitAuthzCreate)}>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12}>
                            <CustomSelect 
                                callback={handleAuthorizationChange}
                                selectId={'aaISCIR'} 
                                selectType={SelectTypes.ANGAJAT_AUTORIZAT_ISCIR} 
                                value={defaultValues.lAuthorization.autorizatie.authISCIR} 
                                register={{...register('lAuthorization.autorizatie.authISCIR', {required: ValidationMessages.REQUITED_MESSAGE})}}
                                error={!!errors?.lAuthorization?.autorizatie?.authISCIR}
                                helperText={errors?.lAuthorization?.autorizatie?.authISCIR ? errors.lAuthorization.autorizatie.authISCIR.message : null}
                            />
                        </Grid>

                    {
                        (() => {
                            if(selectedAuthorization == null){
                                return(
                                    <React.Fragment></React.Fragment>
                                );
                            }
                            else if(selectedAuthorization === AuthzIscirAFCode.OperatorRSVTI){
                                return(
                                    <AuthorizationFragment.AuthorizationRsvtiOperator />
                                );
                            }
                            else{
                                return(
                                    <AuthorizationFragment.AuthorizationRsvtiStandard />
                                );
                            }
                        })()
                    }
                    </Grid>

                    <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                        {/*row*/}
                        <Grid item xs={12} container justifyContent="flex-end" alignItems="flex-end">
                            <Button variant="outlined" type="submit" sx={{ marginRight: 1}}>Salveaza</Button>
                        </Grid>
                    </Grid>

                </form>
                </FormProvider>

            </Stack>
        </Box>
        </Container>
    );

}

export default AuthorizationIscirNew